/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { IconBaseProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconMarket16 = forwardRef<SVGSVGElement, IconBaseProps>(function IconMarket16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <mask
                id="dc-Market16-a"
                style={{ maskType: 'alpha' }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="16"
                height="16"
            >
                <rect width="16" height="16" rx="6" fill="#FF5226" />
            </mask>
            <g mask="url(#dc-Market16-a)">
                <path fill="#FF5226" d="M0 0h16v16H0z" />
                <path
                    d="M6.949 1.083-2.611 16h4.09L7.27 6.981l-.126-.057-1.43 5.744 3.027.533 3.11-3.908-.168-.085-1.05 4.44 6.906-1.315-1.352-2.225-2.683.613.28.323 1.107-4.638-2.577-1.724-3.377 4.246.168.084 1.387-5.562L6.95 1.083Z"
                    fill="#FD0"
                />
            </g>
        </SVGContainer>
    );
});

const IconMarket24 = forwardRef<SVGSVGElement, IconBaseProps>(function IconMarket24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <mask
                id="dc-Market24-a"
                style={{ maskType: 'alpha' }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
            >
                <rect width="24" height="24" rx="6" fill="#FF5226" />
            </mask>
            <g mask="url(#dc-Market24-a)">
                <path fill="#FF5226" d="M0 0h24v24H0z" />
                <path
                    d="M10.423 1.624-3.918 24h6.135l8.688-13.528-.188-.086-2.145 8.616 4.54.8 4.666-5.863-.253-.126-1.576 6.66 10.36-1.973-2.028-3.338-4.024.92.42.484 1.66-6.956-3.866-2.586-5.065 6.368.253.127 2.08-8.344-5.316-3.551Z"
                    fill="#FD0"
                />
            </g>
        </SVGContainer>
    );
});

export const IconMarket = forwardRef<SVGSVGElement, IconBaseProps>(function IconMarket(props, ref) {
    const { size = '16' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
    } as const;

    switch (size) {
        case '16':
            return <IconMarket16 {...iconProps} />;
        case '24':
            return <IconMarket24 {...iconProps} />;
        default:
            return <IconMarket24 {...iconProps} />;
    }
});
